export enum Severity {
  Debug = -4,
  Info = 0,
  Warning = 4,
  Critical = 8
}
